// extracted by css-extract-rspack-plugin
export default {"root":"CardContent_root__c6Utv"};